/**
 * Error codes returned in socket acks and REST error bodies.
 * Keep them stable: the web app maps each code to an i18n key `errors.<CODE>`.
 */
export const ERROR_CODES = [
    // generic
    "UNAUTHENTICATED",
    "FORBIDDEN",
    "REAUTH_REQUIRED",
    "VALIDATION",
    "RATE_LIMITED",
    "MAINTENANCE",
    "LICENSE_REQUIRED", // real-money feature called with a Regular license
    "LICENSE_INVALID",
    "INTERNAL",
    // betting
    "ROUND_CLOSED",
    "ROUND_NOT_FOUND",
    "BET_NOT_FOUND",
    "BET_ALREADY_PLACED",
    "BET_ALREADY_CASHED",
    "BET_LIMIT_EXCEEDED",
    "INSUFFICIENT_FUNDS",
    "CURRENCY_DISABLED",
    "AUTO_CASHOUT_INVALID",
    "CASHOUT_TOO_LATE",
    "PLAYER_LIMIT_REACHED",
    "SELF_EXCLUDED",
    // wallet
    "WITHDRAW_LOCKED",
    "GATEWAY_UNAVAILABLE",
    // chat
    "CHAT_DISABLED",
    "CHAT_MUTED",
];
export const ok = (data) => ({ ok: true, data });
export const fail = (code, message, details) => ({
    ok: false,
    error: {
        code,
        ...(message !== undefined ? { message } : {}),
        ...(details !== undefined ? { details } : {}),
    },
});
/** Thrown server-side; the gateway converts it to an ack / HTTP response. */
export class CrashXError extends Error {
    code;
    details;
    constructor(code, message, details) {
        super(message ?? code);
        this.code = code;
        this.details = details;
        this.name = "CrashXError";
    }
    toAck() {
        return fail(this.code, this.message, this.details);
    }
}
//# sourceMappingURL=errors.js.map